export default "__VITE_ASSET__b6Oq388c__"